function languageLabelUpdates() {
    const localSelectors = document.querySelectorAll('.locale-selector a');
    if (localSelectors) {
        localSelectors.forEach((selector) => {
            const oldVal = selector.innerHTML;
            let newVal;
            if (oldVal.includes('English (US)')) {
                newVal = oldVal.replace("English (US)", "EN");
                selector.innerHTML = newVal;
            } else if (oldVal.includes('Français')) {
                newVal = oldVal.replace("Français", "FR");
                selector.innerHTML = newVal;
            } else if (oldVal.includes('Italiano')) {
                newVal = oldVal.replace("Italiano", "IT");
                selector.innerHTML = newVal;
            } else if (oldVal.includes('Deutsch (Deutschland)')) {
                newVal = oldVal.replace("Deutsch (Deutschland)", "DE");
                selector.innerHTML = newVal;
            } else if (oldVal.includes('Español (España)')) {
                newVal = oldVal.replace("Español (España)", "ES");
                selector.innerHTML = newVal;
            } else if (oldVal.includes('Spanish')) {
                newVal = oldVal.replace("Spanish", "ES");
                selector.innerHTML = newVal;
            } else if (oldVal.includes('German')) {
                newVal = oldVal.replace("German", "DE");
                selector.innerHTML = newVal;
            } else if (oldVal.includes('Italian')) {
                newVal = oldVal.replace("Italian", "IT");
                selector.innerHTML = newVal;
            }
        });
    }
}

export { languageLabelUpdates };


// WEBPACK FOOTER //
// ./scriptPartials/languageLabel.js